export const ADD_TEMPLATE    = 'ADD_TEMPLATE';
export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE';
export const SET_TEMPLATES   = 'SET_TEMPLATES';
export const SELECT_TEMPLATE = 'SELECT_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
